import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { apiGet, apiPost } from "../Utils/apiFetch";
import { pick, isEmpty } from "lodash";
import apiPath from "../Utils/apiPath";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import i18n from "../i18n";
import { createContext } from "use-context-selector";
import { withLoader } from "../Utils/constants";

const AuthContext = createContext();
export default AuthContext;
export const AuthProvider = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [casinoModal, setCasinoModal] = useState(false);
  const [search, setSearch] = useState(false);
  const [loginModalShow, setLoginModalShow] = useState(false);
  const [sidebarModal, setSidebarModal] = useState(false);
  const [betCount, setBetCount] = useState(0);
  const [user, setUser] = useState({});
  const [profileData, setProfileData] = useState({});
  const [betLoader, setBetLoader] = useState(false);
  const [sokcetId, setSocketId] = useState({});
  const [userCoins, setUserCoins] = useState({});
  const [defaultStakeLimit, setDefaultStakeLimit] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [oneclickActive, setOneClickActive] = useState(false);
  const [oneClickBid, setOneClickBid] = useState(10);
  const [tab, setTab] = useState("in_play");
  const [homeTab, setHomeTab] = useState("hot");
  const [showAccount, setShowAccount] = useState(true);
  const [sportTab, setSportsTab] = useState("all");
  const [showBets, setShowBets] = useState(false);
  const [tv, setTv] = useState({});
  const [lang, setLang] = useState("en");
  const [refreshAmountLoader, setRefreshAmountLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleRouteChange = async () => {
    let lang = "en";
    const language_dir = localStorage.getItem("language_dir");

    if (!isEmpty(language_dir)) {
      lang = language_dir;
    }
    i18n.changeLanguage(lang);
    setLang(lang);
  };
  const changeLanguage = (type) => {
    localStorage.setItem("language_dir", type);
    i18n.changeLanguage(type);
    setLang(type);
    window.location.reload();
  };
  useEffect(() => {
    handleRouteChange();
  }, []);

  useEffect(() => {
    if (
      location?.pathname?.split("/")[1] !== "match-details" &&
      !isEmpty(sokcetId)
    ) {
      sokcetId.disconnect();
      setSocketId({});
    }
  }, [location]);

  let logoutUser = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    setShowAccount(false);
    setShowSidebar(false);
    setLoginModalShow(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    setSearch(false);
    setSidebarModal(false);
    setTv({});
    setCasinoModal(false);
    setShowBets(false);
    setShowAccount(false);
    setLoginModalShow(false);
  }, [location]);

  let getProfileData = async () => {
    const data = await apiGet(apiPath.userProfile);
    if (data?.status == 200) {
      if (data?.data?.success) {
        setProfileData(data?.data?.results);
        setUserCoins({
          exp: data?.data?.results?.exposure,
          balance: data?.data?.results?.totalCoins,
          exposure: data?.data?.results?.exposure,
          totalCoins: data?.data?.results?.totalCoins,
        });

        setOneClickBid(data?.data?.results?.defaultOneClickBetStake);
        setOneClickActive(data?.data?.results?.isOneClickBetStake);

        setDefaultStakeLimit(data?.data?.results?.defaultStakeLimit);
        if (data?.data?.results?.marketBlockList?.length > 0) {
          setBlockList(
            data?.data?.results?.marketBlockList?.map((res) => {
              return res?.eventId;
            }),
          );
        }
      }
    }
  };
  let loginUser = async (body) => {
    try {
      let hostname = window.location.hostname;
      hostname = hostname.replace(/^www\./, "");
      hostname = hostname.replace(/^ag\./, "");
      body.website = hostname || "SABAEXCH";
      const { status, data } = await apiPost(
        apiPath.loginUser,
        pick(body, ["username", "password", "uniqueId", "website"]),
      );

      if (status === 200) {
        if (data.success) {
          localStorage.setItem("chatId", data.results.platformType);
          localStorage.setItem("token", data.results.token);
          localStorage.setItem("refresh_token", data.results.refresh_token);
          setUser(jwt_decode(data.results.token));
          setLoginModalShow(false);
          navigate("/");
        } else {
          toast.error(data?.message);
        }
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || i18n.t("SomethingWentWrong"));
    }
  };

  useEffect(() => {
    let data = localStorage.getItem("token")
      ? jwt_decode(localStorage.getItem("token"))
      : "";
    setUser(data);
  }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      getProfileData();
      amounutRefresh();
    }
  }, [user]);
  const amounutRefresh = async () => {
    setRefreshAmountLoader(true);
    const { status, data } = await apiGet(apiPath.refreshAmount);
    if (status === 200) {
      if (data.success) {
        setUserCoins({
          exposure: data?.results?.exposure,
          totalCoins: data?.results?.totalCoins,
          exp: data?.results?.exposure,
          balance: data?.results?.totalCoins,
        });
      }
    }
    setRefreshAmountLoader(false);
  };
  const launchCasino = async (request) => {
    await withLoader(setBetLoader, async () => {
      //  console.log(request, "request");
      if (request?.platForm || request?.gameType || request?.casinoType) {
        const { status, data: response_users1 } = await apiPost(
          apiPath.casinoAmountAdd,
          { amount: 0, platForm: request?.platForm },
        );
        if (status === 200) {
          if (response_users1.success) {
            const { status, data: response_users } = await apiPost(
              request?.platForm && request?.gameType && request?.casinoType
                ? apiPath.doLoginAndLaunchGame
                : apiPath.casinoWalletLogin,
              request?.platForm && request?.gameType && request?.casinoType
                ? !isEmpty(request?.gameTableId)
                  ? {
                      userId: response_users1?.data?.aeCasinoUserId,
                      platForm:
                        request?.platForm == "1" ? "" : request?.platForm,
                      gameType: request?.gameType,
                      gameCode: request?.casinoType,
                      gameTableId: request?.gameTableId || "",
                      isLaunchGameTable: true,
                    }
                  : {
                      userId: response_users1?.data?.aeCasinoUserId,
                      platForm:
                        request?.platForm == "1" ? "" : request?.platForm,
                      gameType: request?.gameType,
                      gameCode: request?.casinoType,
                    }
                : {
                    userId: response_users1?.data?.aeCasinoUserId,
                    gameType: request?.gameType,
                    platForm: request?.platForm == "1" ? "" : request?.platForm,
                  },
            );
            if (status === 200) {
              // console.log(response_users,response_users.success,"response_users");
              if (response_users.status) {
                if (response_users.data.status === "0000") {
                  window.location.href = response_users.data.url;
                } else {
                  console.log("chek1");
                  toast.error(response_users?.data?.desc);
                }
              } else {
                console.log("chek2");
                toast.error(response_users?.message);
              }
            } else {
              toast.error(response_users?.message);
            }
          } else {
            toast.error(response_users1?.message);
          }
        } else {
          toast.error(response_users1?.message);
        }
      } else {
        toast.error(i18n.t("ComingSoon"));
      }
    });
  };
  let contextData = {
    user: user,
    loginUser: loginUser,
    logoutUser: logoutUser,
    showSidebar,
    setShowSidebar,

    profileData,
    setUser,
    userCoins,
    setUserCoins,
    amounutRefresh,

    getProfileData,
    refreshAmountLoader,

    launchCasino,

    lang,

    defaultStakeLimit,
    setDefaultStakeLimit,
    blockList,
    setBlockList,
    oneclickActive,
    setOneClickActive,
    oneClickBid,
    setOneClickBid,

    tab,
    setTab,
    homeTab,
    setHomeTab,
    sportTab,
    setSportsTab,
    showBets,
    setShowBets,
    tv,
    setTv,
    sokcetId,
    setSocketId,
    betLoader,
    setBetLoader,
    betCount,
    setBetCount,
    sidebarModal,
    setSidebarModal,
    search,
    setSearch,
    casinoModal,
    setCasinoModal,
    loginModalShow,
    setLoginModalShow,
    changeLanguage,
    showAccount,
    setShowAccount,
  };
  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};
